import React, { useEffect, useRef } from "react";
import MathText from "./MathText";
import { AUTORISATIONS_LECTEUR, origineSite, urlLecteurYoutube } from "../services/lecteurYoutube";

const urlMedia = (url) => {
  try { return new URL(url, `${origineSite()}/`).toString(); } catch { return url; }
};

/** Message bannière avec image, vidéo ou audio : panneau publicitaire plein écran. */
export default function BannierePublicitaire({ banner, onClose }) {
  const bouton = useRef(null);
  const fermer = useRef(onClose);
  fermer.current = onClose;

  useEffect(() => {
    const touche = (e) => { if (e.key === "Escape") fermer.current(); };
    document.addEventListener("keydown", touche);
    bouton.current?.focus({ preventScroll: true });
    return () => document.removeEventListener("keydown", touche);
  }, []);

  const src = urlMedia(banner.media_url);
  return (
    <div className="ql-pub" role="dialog" aria-modal="true" aria-label={banner.title || "Annonce Quick Learning"}>
      <div className="ql-pub-carte">
        <div className="ql-pub-entete">
          <img src="/static/logo.png" alt="" className="ql-pub-logo" />
          <span>Quick Learning</span>
        </div>
        {banner.youtube_id && (
          <div className="ql-pub-media ql-pub-youtube">
            <iframe src={urlLecteurYoutube(banner.youtube_id)} title={banner.title || "Vidéo Quick Learning"}
              allow={AUTORISATIONS_LECTEUR} allowFullScreen />
          </div>
        )}
        {banner.media_type && <div className="ql-pub-media">
          {banner.media_type === "image" && <img src={src} alt={banner.title || ""} />}
          {banner.media_type === "video" && (
            <video src={src} controls autoPlay muted playsInline preload="metadata" />
          )}
          {banner.media_type === "audio" && (
            <div className="ql-pub-audio">
              <i className="bi bi-music-note-beamed" aria-hidden="true"></i>
              <audio src={src} controls preload="metadata" />
            </div>
          )}
        </div>}
        {(banner.title || banner.content) && (
          <div className="ql-pub-texte">
            {banner.title && <h2>{banner.title}</h2>}
            {banner.content && <div className="ql-pub-contenu"><MathText text={banner.content} /></div>}
          </div>
        )}
        {banner.lien && (
          <a className="ql-pub-lien" href={banner.lien} target="_blank" rel="noopener noreferrer">
            En savoir plus <i className="bi bi-box-arrow-up-right"></i>
          </a>
        )}
        <button type="button" ref={bouton} className="ql-pub-quitter" onClick={onClose}>
          <i className="bi bi-hand-index-thumb"></i> Appuyer ici pour quitter
        </button>
      </div>
    </div>
  );
}
